import React from "react";
import { VMSRoutesName } from "route/RouteNamesODoctor";

export const VMSRoutes = [
  {
    path: VMSRoutesName.orderList,
    Component: <>MSD</>,
    exact: true,
  },
];
